import { useTransition, type FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { Button } from '@packages/shared/src/ui/Button/Button';

export type InfiniteLoadingHeaderProps = {
  onLoadMore: () => void;
};

const messages = defineMessages({
  loadMore: {
    id: 'search.productList.infiniteLoading.header.loadMore',
    defaultMessage: 'Vorherige Artikel anzeigen',
  },
});

export const InfiniteLoadingHeader: FC<InfiniteLoadingHeaderProps> = ({ onLoadMore }) => {
  const { formatMessage } = useIntl();
  const [isLoading, startTransition] = useTransition();

  return (
    <div className="[grid-column:1/-1] [grid-row:span_1] mb-2 place-self-center">
      <Button
        disabled={isLoading}
        onClick={() => {
          startTransition(() => {
            onLoadMore();
          });
        }}
        className={isLoading ? 'animate-pulse' : ''}
      >
        {formatMessage(messages.loadMore)}
      </Button>
    </div>
  );
};
